import { PlainDateTime } from "@/temporal"
import { objectSchema } from "vue-utils"
import { Nullable } from "../BaseEntity"

export interface MarriageSignatureVerification {
	IPAddress: Nullable<string>
	Timestamp: Nullable<PlainDateTime>
	IsVerified: boolean
}

export const MarriageSignatureVerificationSchema = objectSchema<MarriageSignatureVerification>({
	IPAddress: Nullable(String),
	Timestamp: Nullable(PlainDateTime.Schema),
	IsVerified: Boolean,
})
